module.exports = __webpack_public_path__ + "static/img/juanmahua.dece045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/juanmahua.png
// module id = rgC5
// module chunks = 1